module.exports = __webpack_public_path__ + "static/media/zind_kanyinya5.03f70259.jpg";